import React, { useRef, useState, useEffect } from 'react';
import { candidatesData } from '../data/mockData';

const CandidateCard = ({ candidate }) => {
  return (
    <div className="candidates-marquee-card flex-shrink-0 w-[320px] lg:w-[380px]">
      {/* Static image */}
      <div className="relative aspect-[3/4] rounded-2xl overflow-hidden bg-[#e8ebe0]">
        <img
          src={candidate.image}
          alt={candidate.name}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      {/* Quote and attribution */}
      <div className="mt-4 px-1">
        <p className="text-[#082900] text-[16px] lg:text-[18px] font-normal leading-[1.3] mb-3 line-clamp-3">
          "{candidate.quote}"
        </p>
        <p className="text-[#082900] text-[13px] lg:text-[14px] font-normal">
          {candidate.name}
        </p>
        <p className="text-[#082900]/50 text-[12px] lg:text-[13px] font-normal">
          {candidate.title}
        </p>
      </div>
    </div>
  );
};

const CandidatesSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const testimonials = candidatesData.testimonials;

  return (
    <section ref={sectionRef} className="bg-[#F9FBF5] py-16 lg:py-24 overflow-hidden">
      {/* Header - constrained width */}
      <div className="max-w-[1121px] mx-auto px-6 lg:px-10">
        <div className={`text-center mb-2 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-[#0A3900] text-[36px] lg:text-[64px] font-light leading-[1] tracking-[-0.011em]">
            {candidatesData.title}
          </h2>
        </div>
        <p className={`text-center text-[#082900] text-[14px] lg:text-[16px] font-normal leading-[1.2] max-w-xl mx-auto mb-12 lg:mb-16 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {candidatesData.subtitle}
        </p>
      </div>

      {/* Infinite horizontal scrolling marquee - full width */}
      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 lg:w-32 bg-gradient-to-r from-[#F9FBF5] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 lg:w-32 bg-gradient-to-l from-[#F9FBF5] to-transparent z-10 pointer-events-none" />

        {/* Scrolling track */}
        <div className="candidates-marquee-track flex gap-6 lg:gap-8">
          {/* Triple the items for seamless infinite loop */}
          {[...testimonials, ...testimonials, ...testimonials].map((candidate, i) => (
            <CandidateCard key={i} candidate={candidate} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CandidatesSection;
